module.exports = __webpack_public_path__ + "static/media/golf-8.af9650cb.png";